import { render, staticRenderFns } from "./BuildingOverview.vue?vue&type=template&id=21b21659&"
import script from "./BuildingOverview.vue?vue&type=script&lang=js&"
export * from "./BuildingOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports